import { c as _c } from "react/compiler-runtime";
import { ListBoxSelect } from '@systemeio/ui';
import { SubAccountInterface } from 'modules/subaccounts/types/sub-account-interface';
import { useEffect, useState } from 'react';
import { useRouter } from 'shared/hooks/use-router';
import useUser from 'shared/hooks/use-user';
import { generatePretendUserUrl } from 'shared/hooks/use-user/utils/generate-pretend-user-url';
import { twJoin, twMerge } from 'tailwind-merge';
import { ChevronDownIcon } from '@systemeio/ui/icons';
import { hasSubAccounts } from 'shared/hooks/use-user/utils/has-subaccounts';
interface SubAccountSelectorProps {
  className?: string;
}
export const SubAccountSelector = t0 => {
  const $ = _c(18);
  const {
    className
  } = t0;
  const {
    dashboardUser,
    isSupportImpersonation,
    avatarUrl
  } = useUser();
  const router = useRouter();
  const [selectedSubAccount, setSelectedSubAccount] = useState(null);
  let t1;
  let t2;
  if ($[0] !== dashboardUser) {
    t1 = () => {
      if (dashboardUser && hasSubAccounts(dashboardUser)) {
        const selectedSubAccount_0 = dashboardUser.subaccounts.find(subAccount => subAccount.user.id === dashboardUser.id) ?? dashboardUser.mainUser;
        setSelectedSubAccount(selectedSubAccount_0);
      }
    };
    t2 = [dashboardUser];
    $[0] = dashboardUser;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== dashboardUser) {
    t3 = () => {
      if (!dashboardUser || !hasSubAccounts(dashboardUser) || !dashboardUser.mainUser) {
        return;
      }
      const getCustomCaption = _temp;
      return [{
        id: dashboardUser.mainUser.user.id,
        caption: dashboardUser.mainUser.displayName,
        customCaption: getCustomCaption(dashboardUser?.subaccountsAvatarUrls[dashboardUser.mainUser.user.id] ?? undefined, dashboardUser.mainUser.displayName)
      }, ...dashboardUser.subaccounts.map(t4 => {
        const {
          user: t5,
          displayName
        } = t4;
        const {
          id
        } = t5;
        return {
          id,
          caption: displayName,
          customCaption: getCustomCaption(dashboardUser?.subaccountsAvatarUrls[id] ?? undefined, displayName)
        };
      })];
    };
    $[3] = dashboardUser;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const subAccountsData = t3;
  let t4;
  if ($[5] !== dashboardUser?.id || $[6] !== dashboardUser?.mainUser || $[7] !== isSupportImpersonation || $[8] !== router) {
    t4 = id_0 => {
      if (!id_0 || id_0 === dashboardUser?.id || !dashboardUser?.mainUser) {
        return;
      }
      const isImpersonateToMainAccount = id_0 === dashboardUser?.mainUser.user.id;
      let query = encodeURIComponent(id_0);
      if (isImpersonateToMainAccount && !isSupportImpersonation) {
        query = "_exit";
      }
      router.push(generatePretendUserUrl(query));
    };
    $[5] = dashboardUser?.id;
    $[6] = dashboardUser?.mainUser;
    $[7] = isSupportImpersonation;
    $[8] = router;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const changeSubAccount = t4;
  let t5;
  if ($[10] !== avatarUrl || $[11] !== changeSubAccount || $[12] !== className || $[13] !== dashboardUser || $[14] !== selectedSubAccount?.displayName || $[15] !== selectedSubAccount?.user || $[16] !== subAccountsData) {
    t5 = hasSubAccounts(dashboardUser) ? <ListBoxSelect optionsClassName="z-50 cursor-pointer" buttonClassName="rounded-md" value={selectedSubAccount?.user.id} onChange={value => changeSubAccount(value)} data={subAccountsData()}>{open => <div className={twMerge("border-text-secondary/30 flex flex-row items-center justify-between break-all rounded-md border bg-transparent px-4 py-2 text-black", className)}><div className="flex items-center gap-3">{avatarUrl && <img className="h-[28px] w-[28px] min-w-[28px] overflow-hidden rounded-full object-cover" src={avatarUrl} alt={selectedSubAccount?.displayName} />}<span className="text-wrap text-start truncate">{selectedSubAccount?.displayName}</span></div><ChevronDownIcon className={twJoin("h-3 w-3 transition-transform", open && "rotate-180")} aria-hidden="true" /></div>}</ListBoxSelect> : null;
    $[10] = avatarUrl;
    $[11] = changeSubAccount;
    $[12] = className;
    $[13] = dashboardUser;
    $[14] = selectedSubAccount?.displayName;
    $[15] = selectedSubAccount?.user;
    $[16] = subAccountsData;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};
function _temp(image, name) {
  return <div className="text-start flex items-center gap-3">{image && <img className="h-7 w-7 overflow-hidden rounded-full object-cover" src={image} alt={name} />}<div className="flex flex-col">{name}</div></div>;
}